import { FC } from 'react';
import { Button } from '../../atoms';
import styles from './LandscapeCommoditiesTemplate.module.css';
import { Container } from 'react-bootstrap';
import BaseTemplate from '../../templates/BaseTemplate';
import { useNavigate, useParams } from 'react-router-dom';
import LandscapeBaseEditTemplate from '../../../templates/LandscapeBaseEditTemplate';
import { LandscapeCommoditiesOrganism } from '../../organisms';
import { LandscapeCommodityResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-commodity-response.dto';

export interface LandscapeCommoditiesTemplateProps {
  commodities: LandscapeCommodityResponseDto[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeCommoditiesTemplate: FC<LandscapeCommoditiesTemplateProps> = ({
  commodities,
  handleEdit,
  handleDelete,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const onAddCommodityClick = () => {
    navigate(`/landscapes/edit/${id}/commodities/add`);
  };

  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseEditTemplate>
          <div className={styles.button}>
            <Button
              variant="dark"
              className={styles.buttonWithIcon}
              onClick={onAddCommodityClick}
            >
              Add Commodity
            </Button>
          </div>
          <LandscapeCommoditiesOrganism
            content={commodities}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </LandscapeBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeCommoditiesTemplate;
